<script context="module">
    import { get } from "svelte/store";

    import {
        user,
        ShowErrorModal,
        ErrorDetail,
        ErrorModalCloseFunction,
        preventRedirect,
        preventRedirectObj,
        ShowInfoModal,
        InfoDetail,
        previewImageObj,
        showImagePreviewModal,
        LastListUrl,
        serverDisconnectionReason,
        showServerDisconnectionModal,
        CalendarEventCategories,
        EncounterSidePanelProps,
        defaultFilters,
        IsLoadingCalendarEventCategories,
        prePopulateAccountOptions,
        insuranceFund,
        accounts,
        accountDoctors,
        loggedInDoctorDetail,
        viewLogDetails,
        showViewLogModal,
        showGlobalNotificationModal,
        globalNotificationModalDetails,
        showCommunicationConfirmationModal,
        communicationConfirmationModalDetails,
        showConfirmActionModal,
        confirmActionModalDetails,
        preOpQuestionnaires,
        preOpInstructions,
        postOpSurveys,
        tableScrollPosition,
    } from "../stores";

    import { push, pop, replace } from "svelte-spa-router";

    import isEmail from "validator/lib/isEmail";

    import { cloneDeep } from "lodash";

    import {
        GenderType,
        InsuranceType,
        MFAType,
        TitleType,
        BillingStatus,
        EstimatePaidByType,
        EstimatePaidMethodType,
        EstimatePaidForType,
        opvStatusMedicare,
        opvStatusHealthFund,
        HospitalType,
        BillingType,
        OOPType,
        eligibilityStatusMedicare,
        eligibilityStatusHealthFund,
        claimStatus,
        claimERAStatus,
        paymentStatus,
        doctorStatus,
        UserStatus,
        authenticatorTypes,
        providerBupaStatus,
        providerHcfStatus,
        providerNibStatus,
        activityLogsActionType,
        announcementsType,
        encounterBillingType,
        encounterNeuraxialType,
        opvStatusDVA,
        months,
        QuoteBillingStatus,
        accountCalendarEventType,
        accountCalendarRepeatIntervalType,
        QuoteStatuses,
        RuleType,
        handOverType,
        estimateStatus,
        invoiceStatus,
        DeleteRepeatingEventOptions,
        DirectUserRoles,
        userFilterTypes,
        encounterStatus,
        BillingItemCodeType,
        CommunicationStatuses,
        PrivateInsuranceFundCoverType,
        paymentTag,
        encounterPaymentDropdownOptions,
        InvoiceReasons,
    } from "./utilEnums.svelte";

    import {
        defaultCalendarEventColor,
        FallBackEncounterDurationMins,
        FallBackGroupId,
        GOOGLE_MAP_CONFIG,
        X_Device_ID,
    } from "./utilConstants.svelte";

    import { apiMethods } from "../Services/index.svelte";

    import cryptoJS from "crypto-js";

    import { isEqual } from "lodash";

    import { cacheDefaultFilters } from "./utilCache.svelte";

    import Papa from "papaparse";

    import { isEnvApp } from "./utilRoute.svelte";

    const isProd = process.env.isProd;
    const locationDetails = document.location;
    const prodUrl = `${
        locationDetails.protocol == "http:"
            ? "https:"
            : locationDetails.protocol
    }//${locationDetails.hostname}${
        locationDetails.port ? ":" + locationDetails.port : ""
    }/${process.env.PROD_API_URL_SUFFIX}`;
    const devUrl = `http://${locationDetails.hostname}:${process.env.DEV_API_PORT}/api`;
    //const devUrl = `https://new.tcihealth.com.au/api`;

    let googleMapsScript;

    export const serverUrl = isProd ? prodUrl : devUrl;

    export let globalAbortController = new AbortController();

    export const refreshToken = async () => {
        if (localStorage.getItem("isTokenRefreshing") === "true") return false;

        localStorage.setItem("isTokenRefreshing", "true");

        const userData =
            JSON.parse(localStorage.getItem("TciSavedUser")) || get(user);

        const userToken = userData?.token || "";
        const refreshToken = userData?.refreshToken || "";

        if (!userToken || !refreshToken) {
            localStorage.setItem("isTokenRefreshing", "false");
            return false;
        }

        const data = {
            token: userToken,
            refreshToken: refreshToken,
            source: "Dashboard",
            timeZoneOffset: new Date().getTimezoneOffset(),
        };

        const requestObject = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": "true",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "POST",
                "X-Device-Id": X_Device_ID,
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify(data),
        };

        try {
            const response = await fetch(
                `${serverUrl}/Login/RefreshToken`,
                requestObject,
            );
            if (response.ok) {
                const res = await response.json();
                user.set({
                    ...get(user),
                    token: res.token,
                    refreshToken: res.refreshToken,
                    expiration: res.expiration,
                });
                localStorage.setItem("isTokenRefreshing", "false");
                return true;
            } else {
                localStorage.setItem("isTokenRefreshing", "false");
                return false;
            }
        } catch (error) {
            console.error("Failed to refresh token:", error);
            localStorage.setItem("isTokenRefreshing", "false");
            return false;
        }
    };

    export const signOut = (msg = {}, isServerDisconnect = false) => {
        if (isServerDisconnect) {
            showServerDisconnectionModal.set(true);
            serverDisconnectionReason.set(getSignOutReason(msg));
            user.set({
                token: null,
                refreshToken: null,
                expiration: null,
                name: null,
                id: null,
                role: null,
                uniqueId: null,
                settings: {},
                groupId: null,
                groupName: null,
                defaultFilters: null,
                email: null,
            });
            window.location = "/#/";
            return;
        }

        const userData = get(user);
        const userToken = userData == null ? "" : userData.token;

        if (userToken) {
            var requestObject = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "true",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "POST",
                    Authorization: "Bearer " + userToken,
                },
                mode: "cors",
                cache: "no-cache",
            };

            requestObject.headers["X-Device-Id"] = X_Device_ID;

            const reason = getSignOutReason(msg);

            fetch(
                `${serverUrl}/Login/Logout${reason ? `?reason=${reason}` : ""}`,
                requestObject,
            );
        }
        user.set({
            token: null,
            refreshToken: null,
            expiration: null,
            name: null,
            id: null,
            role: null,
            uniqueId: null,
            settings: {},
            groupId: null,
            groupName: null,
            defaultFilters: null,
            email: null,
        });
        showServerDisconnectionModal.set(false);
        serverDisconnectionReason.set("");
        defaultFilters.set({});
        insuranceFund.set([]);
        accounts.set([]);
        accountDoctors.set([]);
        loggedInDoctorDetail.set({});
        prePopulateAccountOptions.set([]);
        preOpQuestionnaires.set([]);
        preOpInstructions.set([]);
        postOpSurveys.set([]);
        window.location = "/#/";
    };

    const getSignOutReason = (msg) => {
        const { url, errorStatus, reason } = msg;
        const userData = get(user);

        if (url)
            return `User (id: ${userData.id}) access ${url}, received error ${errorStatus ? errorStatus : ""}`;

        if (reason) return reason;

        return "";
    };

    export const resetPreventRedirectProperty = () => {
        preventRedirect.set(false);
        preventRedirectObj.set({
            showModal: false,
            message: "Unable to redirect",
            btnOptions: [],
        });
    };

    export const checkTokenExpiration = async (retryCount = 0) => {
        const MAX_RETRIES = 5;

        // no saved user details - no user logged in
        if (!get(user).expiration) return "valid";

        const now = new Date();
        const expirationDate = new Date(get(user).expiration);

        // Expiration in the future
        if (now <= expirationDate) {
            return "valid";
        }

        // Long expiration, probably no data
        if (now.getFullYear() > expirationDate.getFullYear()) {
            signOut({ reason: "Token expired" }, true);
            return "expired";
        }

        localStorage.setItem("isTokenRefreshing", "true");

        const refreshSuccess = await refreshToken();

        localStorage.setItem("isTokenRefreshing", "false");

        if (!refreshSuccess) {
            if (retryCount >= MAX_RETRIES) {
                console.error(
                    "Reached maximum retry attempts. Token refresh failed.",
                );
                signOut(
                    { reason: "Token refresh failed after maximum retries" },
                    true,
                );
                return "expired";
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));
            await refreshToken();
            return await checkTokenExpiration(++retryCount);
        }

        return "refreshed";
    };

    export const goToURL = (url, openWithNewTab = false) => {
        if (openWithNewTab) window.open(`/#${url}`, "_blank");
        else {
            saveLastListView(location.hash);
            push(url);
        }
    };

    const saveLastListView = (lastHash) => {
        if (
            lastHash.indexOf("/", 2) === lastHash.lastIndexOf("/") ||
            lastHash.lastIndexOf("/") === 1
        ) {
            LastListUrl.set(lastHash);
        }
    };

    export const goBack = () => {
        pop();
    };

    export const backToList = () => {
        const lastListUrl = get(LastListUrl);
        if (lastListUrl) push(lastListUrl);
        else goBack();
    };

    export const historyBack = () => {
        history.back();
    };

    // navigate to a new page but without adding a new entry in the browser's history
    export const replaceURL = (url) => {
        replace(url);
    };

    export const getUrlWithoutSearch = () => {
        const url = window.location.href;

        try {
            const urlObj = new URL(url);

            urlObj.search = "";

            window.history.replaceState(null, "", urlObj.toString());
        } catch (e) {
            return url;
        }
    };

    export const getDate = (d, symbol = "-", isGMT) => {
        if (isGMT) {
            const date = new Date(d);
            const year = date.getFullYear();
            const month =
                date.getMonth() + 1 >= 10
                    ? date.getMonth() + 1
                    : "0" + (date.getMonth() + 1);
            const day =
                date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();

            return `${year}${symbol}${month}${symbol}${day}`;
        } else {
            if (d) {
                const dateArr = d.split("T")[0].split("-");

                if (!symbol) symbol = "-";

                if (dateArr.length == 3)
                    return `${dateArr[0]}${symbol}${dateArr[1]}${symbol}${dateArr[2]}`;
            } else return "No date specified yet...";
        }
    };

    export const getTotalDaysInOffsetMonth = (date, monthOffset) => {
        if (!(date instanceof Date)) return -1;

        let year = date.getFullYear();
        let month = date.getMonth();

        const newDate = new Date(year, month + monthOffset, 1);

        const newYear = newDate.getFullYear();
        const newMonth = newDate.getMonth() + 1;

        return new Date(newYear, newMonth, 0).getDate();
    };

    export const getFormatDate = (d, symbol = "/") => {
        if (!d) return "-";

        const dateArr = d.split("T")[0].split("-");

        return `${dateArr[2]}${symbol}${dateArr[1]}${symbol}${dateArr[0]}`;
    };

    export const toLocalDateString = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
    }

    export const getFormatBirthDate = (d, symbol = "/") => {
        if (!d) return "-";

        const dateArr = d.split("T")[0].split("-");
        const dob = new Date(d);
        if (dob >= new Date()) return "-";
        let ageString;

        const yearDiff = new Date().getFullYear() - dob.getFullYear();
        const monthDiff = new Date().getMonth() - dob.getMonth();
        const dateDiff = new Date().getDate() - dob.getDate();

        if (yearDiff > 2) {
            if (monthDiff > 0 || (monthDiff === 0 && dateDiff >= 0)) {
                ageString = `${yearDiff} yrs`;
            } else {
                ageString = `${yearDiff - 1} yrs`;
            }
        } else if (yearDiff === 2) {
            if (monthDiff > 0 || (monthDiff === 0 && dateDiff >= 0)) {
                ageString = `${yearDiff} yrs`;
            } else {
                const mo = 24 + monthDiff + (dateDiff < 0 ? -1 : 0);
                ageString = `${mo} mo`;
            }
        } else {
            const mo = 12 * yearDiff + monthDiff + (dateDiff < 0 ? -1 : 0);
            ageString = `${mo} mo`;
        }

        return `${dateArr[2]}${symbol}${dateArr[1]}${symbol}${dateArr[0]} (${ageString})`;
    };

    export const getFormatDateAndTime = (
        d,
        symbol = "/",
        isDateBefore = true,
        showDayOfWeek = false,
        timeSeparator = ","
    ) => {
        if (!d || d.split("-")[0] == "0001") return "-";

        const date = new Date(d);
        const dayOfWeek =
            date.toLocaleString("en-AU", { weekday: "short" }) + ", ";

        const timeStr = d.split("T")[1].split(":").slice(0, 2);

        if (!isDateBefore)
            return `${showDayOfWeek ? dayOfWeek : ""}${timeStr.join(":")}, ${getFormatDate(d, symbol)}`;

        return `${showDayOfWeek ? dayOfWeek : ""}${getFormatDate(d, symbol)}${timeSeparator} ${timeStr.join(":")}`;
    };

    export const getFormatDateAndTimeWithSeconds = (
        d,
        symbol = "/",
        isDateBefore = true,
        showDayOfWeek = false,
        timeSeparator = ","
    ) => {
        if (!d || d.split("-")[0] == "0001") return "-";

        const date = new Date(d);
        const dayOfWeek =
            date.toLocaleString("en-AU", { weekday: "short" }) + ", ";

        const timeStr = d.split("T")[1].split(":").slice(0, 3);

        if (!isDateBefore)
            return `${showDayOfWeek ? dayOfWeek : ""}${timeStr.join(":")}, ${getFormatDate(d, symbol)}`;

        return `${showDayOfWeek ? dayOfWeek : ""}${getFormatDate(d, symbol)}${timeSeparator} ${timeStr.join(":")}`;
    };

    export const getDateFromDateString = (
        dateStr = "",
        symbol = "/",
        isDateOnly = false,
        showDayOfWeek = false,
    ) => {
        if (!dateStr) return "";

        const originalDate = new Date(dateStr);
        const dayOfWeek =
            originalDate.toLocaleString("en-AU", { weekday: "short" }) + ", ";

        const year = originalDate.getFullYear();
        const month = (originalDate.getMonth() + 1).toString().padStart(2, "0");
        const day = originalDate.getDate().toString().padStart(2, "0");
        const hours = originalDate.getHours().toString().padStart(2, "0");
        const minutes = originalDate.getMinutes().toString().padStart(2, "0");
        const seconds = originalDate.getSeconds().toString().padStart(2, "0");

        const formattedDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        if (isDateOnly)
            return `${showDayOfWeek ? dayOfWeek : ""}${getFormatDate(formattedDateString, symbol)}`;

        return `${showDayOfWeek ? dayOfWeek : ""}${getFormatDateAndTime(formattedDateString, symbol)}`;
    };

    export const getDisplayDate = (date, locale = "en-AU") => {
        if (!date) return "";

        date = new Date(date);

        const weekday = date.toLocaleString(locale, { weekday: "short" });
        const day = date.toLocaleString(locale, { day: "numeric" });
        const month = date.toLocaleString(locale, { month: "long" });
        const year = date.toLocaleString(locale, { year: "numeric" });

        return `${weekday}, ${day} ${month} ${year}`;
    };

    export const getText = (text, defaultText) => {
        if (text) return text;
        else return defaultText ? defaultText : "";
    };

    export const getNumber = (num, decimals = 0) => {
        if (typeof num !== "number" || isNaN(num)) return "invalid number";

        return num.toFixed(decimals);
    };

    export const getNumberWithComma = (num, decimals = 0) => {
        if (typeof num !== "number" || isNaN(num)) return "invalid number";

        return Number(num).toLocaleString("en-US", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    };

    export const getTitle = (id) => {
        if (id == 20) return "";

        return TitleType.find((title) => title.id == id)?.type + ".";
    };

    export const getBoolean = (bool) => {
        if (bool) return "Yes";
        else return "No";
    };

    export const getCommsStatusText = (status) => {
        return CommunicationStatuses[status] ?? "Unknown";
    };

    export const getMonth = (monthId) => {
        return months.find((month) => month.id == monthId)?.name;
    };

    export const getBooleanIcon = (bool, isCsvContent = false) => {
        if (isCsvContent) return bool ? "Yes" : "No";

        if (bool) return `<i class="fa fa-check" aria-hidden="true"></i>`;
        else return `<i class="fa fa-times" aria-hidden="true"></i>`;
    };

    export const getMFAType = (id) => {
        return MFAType.find((mfaType) => mfaType.id == id)?.type;
    };

    export const getGenderType = (id) => {
        return GenderType.find((gender) => gender.id == id)?.type;
    };

    export const getInsuranceType = (id, property = "") => {
        // Merge Insurance type 0, 1, 2 to 0 (Private)
        if (id == 1 || id == 2) id = 0;

        if (!property) {
            // Merge Insurance type 25, 26 to Defence
            if (id === 25 || id === 26) return "Australian Defence Force";

            if (InsuranceType.some((insurance) => insurance.id == id))
                return InsuranceType.find((insurance) => insurance.id == id)
                    ?.type;
            else return "Unknown insurance type";
        } else {
            if (InsuranceType.some((insurance) => insurance.id == id)) {
                const targetInsuranceType = InsuranceType.find(
                    (insurance) => insurance.id == id,
                );

                if (
                    targetInsuranceType &&
                    targetInsuranceType.hasOwnProperty(property)
                )
                    return targetInsuranceType[property];

                return targetInsuranceType?.type ?? "Unknown insurance type";
            } else return "Unknown insurance type";
        }
    };

    export const getHospitalType = (id) => {
        if (HospitalType.some((hospital) => hospital.id == id))
            return HospitalType.find((hospitalType) => hospitalType.id == id)
                ?.type;
        else return "Unknown";
    };

    export const getBillingStatus = (id, property = "") => {
        if (!property)
            return BillingStatus.find((billingStatus) => billingStatus.id == id)
                ?.type;

        const targetBillingStatus = BillingStatus.find(
            (billingStatus) => billingStatus.id == id,
        );

        if (targetBillingStatus && targetBillingStatus.hasOwnProperty(property))
            return targetBillingStatus[property];

        return targetBillingStatus?.type ?? "Unknown billing status";
    };

    export const getQuoteBillingStatus = (id) => {
        return QuoteBillingStatus.find(
            (billingStatus) => billingStatus.id == id,
        )?.type;
    };

    export const getQuoteStatus = (id) => {
        return QuoteStatuses.find((s) => s.id == id)?.type;
    };

    export const getFeeEstimateDisplayStatus = (feeEstimate) => {
        //this converts billing status to one of the fee estimate display statuses
        if(feeEstimate.billingStatus == 0)
            return feeEstimate.billingStatus;
        else if(feeEstimate.billingStatus == 1) {
            //check estimate status
            if(feeEstimate.estimates.length > 0){
                let estimate = feeEstimate.estimates[feeEstimate.estimates.length - 1]; //get last estimate
                if(estimate.status == 4) {
                    //approved    
                    return 3;
                }
                if(estimate.status == 5) {
                    //rejected
                    return 2;
                }
                return feeEstimate.billingStatus;
            }
        }
        return feeEstimate.billingStatus; //default, this will not always be entered
    }

    export const getQuoteOnlyDisplayStatus = (id, property = "") => {
         if (!property)
            return QuoteStatuses.find((billingStatus) => billingStatus.id == id)
                ?.type;

        const targetBillingStatus = QuoteStatuses.find(
            (billingStatus) => billingStatus.id == id,
        );

        if (targetBillingStatus && targetBillingStatus.hasOwnProperty(property))
            return targetBillingStatus[property];

        return targetBillingStatus?.type ?? "Unknown billing status";
    }

    export const getDoctorStatus = (id) => {
        return doctorStatus.find((doctorStatus) => doctorStatus.id == id)?.type;
    };

    export const getUserStatus = (id) => {
        return UserStatus.find((status) => status.id == id)?.type;
    };

    export const getBillingType = (id) => {
        return BillingType.find((billingType) => billingType.id == id)?.type;
    };

    export const getInvoiceReason = (id) => {
        return InvoiceReasons.find((billingType) => billingType.id == id)?.type ?? "-";
    };

    export const getBillingItemCodeType = (type) => {
        return BillingItemCodeType.find((bit) => bit.id == type)?.type;
    };

    export const getOOPType = (id) => {
        if (!id) id = 0;
        return OOPType.find((oopType) => oopType.id == id)?.type;
    };

    export const getBillingRuleType = (id) => {
        if (!id) id = 0;
        return RuleType.find((oopType) => oopType.id == id)?.type;
    };

    export const getEstimatePaidFor = (id) => {
        if (EstimatePaidForType.some((type) => type.id == id))
            return EstimatePaidForType.find((type) => type.id == id)?.type;
        else return "No valid data yet...";
    };

    export const getEstimatePaidBy = (id) => {
        if (EstimatePaidByType.some((type) => type.id == id))
            return EstimatePaidByType.find((type) => type.id == id)?.type;
        else return "No valid data yet...";
    };

    export const getEstimatePaidMethod = (id) => {
        if (EstimatePaidMethodType.some((type) => type.id == id))
            return EstimatePaidMethodType.find((type) => type.id == id)?.type;
        else return "No valid data yet...";
    };
    export const getOpvStatusDVA = (id) => {
        return opvStatusDVA.find((type) => type.id == id)?.type ?? "Unknown";
    };

    export const getOpvStatusMedicare = (id) => {
        if (opvStatusMedicare.some((type) => type.id == id))
            return opvStatusMedicare.find((type) => type.id == id)?.type;
        else return "Unknown";
    };

    export const getOpvStatusHealthFund = (id) => {
        if (opvStatusHealthFund.some((type) => type.id == id))
            return opvStatusHealthFund.find((type) => type.id == id)?.type;
        else return "Unknown";
    };

    export const getEligibilityStatusMedicare = (id) => {
        if (eligibilityStatusMedicare.some((type) => type.id == id))
            return eligibilityStatusMedicare.find((type) => type.id == id)
                ?.type;
        else return "Unknown";
    };

    export const getEligibilityStatusHealthFund = (id) => {
        if (eligibilityStatusHealthFund.some((type) => type.id == id))
            return eligibilityStatusHealthFund.find((type) => type.id == id)
                ?.type;
        else return "Unknown";
    };

    export const getClaimStatus = (id, property = "") => {
        if (!property) {
            if (claimStatus.some((type) => type.id == id))
                return claimStatus.find((type) => type.id == id)?.type;
            else return "Unknown";
        }

        const targetClaimStatus = claimStatus.find((cs) => cs.id == id);

        if (targetClaimStatus && targetClaimStatus.hasOwnProperty(property))
            return targetClaimStatus[property];

        return targetClaimStatus?.type ?? "Unknown";
    };

    export const getClaimERAStatus = (id) => {
        if (claimERAStatus.some((type) => type.id == id))
            return claimERAStatus.find((type) => type.id == id)?.type;
        else return "Unknown";
    };

    export const getPaymentStatus = (id) => {
        if (paymentStatus.some((type) => type.id == id))
            return paymentStatus.find((type) => type.id == id)?.type;
        else return "";
    };

    export const getAuthenticatorType = (id) => {
        if (authenticatorTypes.some((type) => type.id == id))
            return authenticatorTypes.find((type) => type.id == id)?.type;
        else return "No valid authenticator types...";
    };

    export const getHandOverType = (id, showType = "type") => {
        if (handOverType.some((type) => type.id == id))
            return handOverType.find((type) => type.id == id)?.[showType];
        return "No valid hand-over type found...";
    };

    export const getUserFilterType = (id) => {
        if (userFilterTypes.some((type) => type.id == id))
            return userFilterTypes.find((type) => type.id == id)?.type;
        else return "No valid user filter type found...";
    };

    export const setInputFilter = (textbox, inputFilter, errMsg) => {
        [
            "input",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "select",
            "contextmenu",
            "drop",
            "focusout",
        ].forEach(function (event) {
            try {
                textbox.addEventListener(event, function (e) {
                    if (inputFilter(this.value)) {
                        // Accepted value
                        if (
                            ["keydown", "mousedown", "focusout"].indexOf(
                                e.type,
                            ) >= 0
                        ) {
                            this.classList.remove("input-error");
                            this.setCustomValidity("");
                        }
                        this.oldValue = this.value;
                        this.oldSelectionStart = this.selectionStart;
                        this.oldSelectionEnd = this.selectionEnd;
                    } else if (this.hasOwnProperty("oldValue")) {
                        // Rejected value - restore the previous one
                        this.classList.add("input-error");
                        this.setCustomValidity(errMsg);
                        this.reportValidity();
                        this.value = this.oldValue;
                        this.setSelectionRange(
                            this.oldSelectionStart,
                            this.oldSelectionEnd,
                        );
                    } else {
                        // Rejected value - nothing to restore
                        this.value = "";
                    }
                });
            } catch (error) {}
        });
    };

    export const getAmountInCurrency = (balance, inputCurrency) => {
        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: inputCurrency ? inputCurrency : "AUD",
        });
        return formatter.format(balance).replace("A", "");
    };

    export const getAmountInShort = (balance) => {
        if (!balance) return "$0.00";

        if (typeof balance !== "number" || isNaN(balance))
            return "invalid balance";

        if (balance < 1000) return "$" + balance;
        else if (balance < 1000000)
            return "$" + (balance / 1000).toFixed(2) + "K";
        else return "$" + (balance / 1000000).toFixed(2) + "M";
    };

    export const handleDownloadPDF = (
        fileContents,
        fileName,
        isDownload = false,
    ) => {
        if (!isDownload) {
            const byteCharacters = atob(fileContents);
            let byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const file = new Blob([byteArray], {
                type: "application/pdf;base64",
            });
            const fileURL = URL.createObjectURL(file);

            window.open(fileURL);
        } else {
            const alink = document.createElement("a");

            document.body.appendChild(alink);

            alink.href = `data:application/pdf;base64,${[fileContents]}`;
            alink.download = fileName;

            alink.click();

            setTimeout(() => {
                window.URL.revokeObjectURL(alink);
                document.body.removeChild(alink);
            }, 0);
        }
    };

    export const downloadJson = (jsonObj, fileName = "jsonContent") => {
        const alink = document.createElement("a");

        document.body.appendChild(alink);

        alink.href = `data:application/json;charset=utf-8,${encodeURIComponent(JSON.stringify(jsonObj))}`;
        alink.download = fileName;

        alink.click();

        setTimeout(() => {
            window.URL.revokeObjectURL(alink);
            document.body.removeChild(alink);
        }, 0);
    };

    export const readJsonFromFileInput = (e) => {
        try {
            return JSON.parse(atob(e.target.result.split(",")[1]));
        } catch (error) {
            return "";
        }
    };

    export const getValidBillingData = (bdArr) => {
        if (!bdArr || !bdArr.length) return {};

        // no billingData has actualGap (actualRebate) nor totalFee (totalAmount)
        if (!bdArr.some((bd) => bd.actualGap && bd.totalFee)) {
            // isLatestInvoiceData > isLatestQuoteData > isLatestBillingData
            if (bdArr.some((bd) => bd.isLatestInvoiceData)) {
                const resArr = bdArr.filter((bd) => bd.isLatestInvoiceData);
                return resArr[resArr.length - 1];
            }

            if (bdArr.some((bd) => bd.isLatestQuoteData)) {
                const resArr = bdArr.filter((bd) => bd.isLatestQuoteData);
                return resArr[resArr.length - 1];
            }

            if (bdArr.some((bd) => bd.isLatestBillingData)) {
                const resArr = bdArr.filter((bd) => bd.isLatestBillingData);
                return resArr[resArr.length - 1];
            }

            return bdArr[bdArr.length - 1];
        }

        const filteredArr = bdArr.filter((bd) => bd.rebate || bd.totalFee);

        // isLatestInvoiceData > isLatestQuoteData > isLatestBillingData
        if (filteredArr.some((bd) => bd.isLatestInvoiceData)) {
            const resArr = filteredArr.filter((bd) => bd.isLatestInvoiceData);
            return resArr[resArr.length - 1];
        }

        if (filteredArr.some((bd) => bd.isLatestQuoteData)) {
            const resArr = filteredArr.filter((bd) => bd.isLatestQuoteData);
            return resArr[resArr.length - 1];
        }

        if (filteredArr.some((bd) => bd.isLatestBillingData)) {
            const resArr = filteredArr.filter((bd) => bd.isLatestBillingData);
            return resArr[resArr.length - 1];
        }

        return bdArr[bdArr.length - 1];
    };

    export const handleGenerateAndDownloadCSV = (
        dataArr,
        fileName = "download",
    ) => {
        // generate csv file
        const csvRows = [];

        if (!dataArr.length) return;

        const headers = Object.keys(dataArr[0]);
        csvRows.push(headers.join(","));

        for (let i = 0; i < dataArr.length; i++) {
            const values = Object.values(dataArr[i]).join(",");
            csvRows.push(values);
        }

        const csvData = csvRows.join("\n");

        // download csv file
        const blob = new Blob([csvData], { type: "text/csv" });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");

        a.setAttribute("href", url);

        a.setAttribute("download", `${fileName}.csv`);

        a.click();
    };

    export const exportContentCSV = (
        data = [],
        fileName = "download",
        config = {
            quotes: false, //or array of booleans
            quoteChar: '"',
            escapeChar: '"',
            delimiter: ",",
            header: true,
            newline: "\r\n",
            skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
            columns: null, //or array of strings
        },
    ) => {
        let csvContent = Papa.unparse(JSON.stringify(cloneDeep(data)), config);

        const csvData = new Blob([`\ufeff${csvContent}`], {
            type: "text/csv;charset=utf-8;",
        });

        let csvURL = window.URL.createObjectURL(csvData);
        const link = document.createElement("a");
        link.href = csvURL;
        link.setAttribute("download", `${fileName}.csv`);
        link.click();
        link.remove();
    };

    export const checkMedicareNoValidation = (medicareNo) => {
        if (!medicareNo || !medicareNo.length || medicareNo.length != 10)
            return false;

        const firstDigit = medicareNo.split("")[0];

        if (Number(firstDigit) < 2 || Number(firstDigit) > 8) return false;

        const weight = [1, 3, 7, 9, 1, 3, 7, 9];
        const checkSum = medicareNo.split("")[8];

        let sum = 0;

        for (let i in weight) {
            sum += medicareNo.split("")[i] * weight[i];
        }

        return sum % 10 == checkSum;
    };

    export const checkAbnValidation = (abn) => {
        if (!abn) return false;

        abn = abn.replace(/\s+/g, "").replace(/-/g, "");

        if (!/^\d{11}$/.test(abn)) return false;

        let sum = 0;
        const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

        for (let i = 0; i < 11; i++) {
            sum += (abn.split("")[i] - (i == 0 ? 1 : 0)) * weights[i];
        }

        // 51 824 753 556
        return sum % 89 === 0;
    };

    export const checkProviderNumberValidation = (providerNumber) => {
        // 988939BJ
        if (!providerNumber) return true;

        if (providerNumber.length != 8) return false;

        let sum = 0;
        const weights = [3, 5, 8, 4, 2];
        const plvCheckArr = [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "j",
            "k",
            "l",
            "m",
            "n",
            "p",
            "q",
            "r",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
        ];
        const digitCheckArr = [
            "y",
            "x",
            "w",
            "t",
            "l",
            "k",
            "j",
            "h",
            "f",
            "b",
            "a",
        ];

        for (let i = 0; i <= 5; i++) {
            if (isNaN(providerNumber[i])) return false;

            if (i != 5) sum += Number(providerNumber[i]) * weights[i];
            else sum += Number(providerNumber[i]);
        }

        const plvChar = providerNumber[6].toLowerCase();

        if (!plvCheckArr.includes(plvChar)) return false;

        sum += plvCheckArr.indexOf(plvChar) * 6;

        const checkDigitValue = sum % 11;

        const digitChar = digitCheckArr[checkDigitValue].toLowerCase();

        const providerCheckDigitChar = providerNumber[7].toLowerCase();

        return digitChar == providerCheckDigitChar;
    };

    export const getPaymentAmountPaid = (paymentsArr) => {
        if (!paymentsArr.length) return getAmountInCurrency(0);

        let sum = 0;

        paymentsArr.map((payment) => {
            if (payment.status == 1)
                sum += payment.amount; // Received
            else if (payment.status == 5) sum -= payment.amount; // Refunded
        });

        return getAmountInCurrency(sum);
    };

    export const changeToSentenceCase = (content) => {
        if (!content) return "";
        if (typeof content === "string") {
            return content.replace(/\w\S*/g, function (txt) {
                return (
                    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                );
            });
        }
    };

    export const getTodayWithTime = () => {
        const date = new Date();
        const tzOffset = -date.getTimezoneOffset();
        const diff = tzOffset >= 0 ? "+" : "-";
        const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, "0");
        return (
            date.getFullYear() +
            "-" +
            pad(date.getMonth() + 1) +
            "-" +
            pad(date.getDate()) +
            "T" +
            pad(date.getHours()) +
            ":" +
            pad(date.getMinutes())
        );
    };

    export const getProviderBupaStatus = (id) => {
        if (id)
            return providerBupaStatus.find(
                (bupa) => bupa.id.toString() == id.toString(),
            )?.type;
        else return providerBupaStatus.find((bupa) => bupa.id == id)?.type;
    };

    export const getProviderHcfStatus = (id) => {
        if (id)
            return providerHcfStatus.find(
                (hcf) => hcf.id.toString() == id.toString(),
            )?.type;
        else return providerHcfStatus.find((hcf) => hcf.id == id)?.type;
    };

    export const getProviderNibStatus = (id) => {
        if (id)
            return providerNibStatus.find(
                (nib) => nib.id.toString() == id.toString(),
            )?.type;
        else return providerNibStatus.find((nib) => nib.id == id)?.type;
    };

    export const sortEnumAlphabetically = (strA = "", strB = "") => {
        if (!strA.length || !strB.length) return;

        if (strA[0] < strB[0]) return -1;
        if (strA[0] > strB[0]) return 1;

        if (strA.length < strB.length) return -1;
        if (strA.length > strB.length) return 1;

        return 0;
    };

    export const getActivityLogsActionType = (actionType) => {
        if (actionType)
            return activityLogsActionType.find(
                (atype) => atype.id == actionType,
            )?.type;
        return "Invalid action type";
    };

    export const importGoogleMapScript = async () => {
        if (!googleMapsScript) {
            googleMapsScript = document.createElement("script");
            googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_CONFIG.PLACE_API_KEY}&libraries=places`;
            googleMapsScript.async = true;
            googleMapsScript.defer = true;
            document.head.appendChild(googleMapsScript);
        } else document.head.appendChild(googleMapsScript);
    };

    export const removeGoogleMapScript = () => {
        if (googleMapsScript) googleMapsScript.remove();
    };

    export const getAnnouncementsType = (type) => {
        if (type || type == 0)
            return announcementsType.find((atype) => atype.id == type)?.type;
        return "Invalid announcement type";
    };

    export const getEncounterBillingType = (type) => {
        if (type || type == 0)
            return encounterBillingType.find((etype) => etype.id == type)?.type;
        return "Invalid encounter billing type";
    };

    export const getEncounterNeuraxialType = (type) => {
        if (type || type == 0)
            return encounterNeuraxialType.find((etype) => etype.id == type)
                ?.type;
        return "Invalid encounter neuraxial type";
    };

    export const getEncounterStatus = (status, property = "") => {
        if (!property) {
            if (status || status == 0)
                return encounterStatus.find((eStatus) => eStatus.id == status)
                    ?.type;
            return "Invalid encounter status";
        }

        const targetEncounterStatus = encounterStatus.find(
            (eStatus) => eStatus.id == status,
        );

        if (
            targetEncounterStatus &&
            targetEncounterStatus.hasOwnProperty(property)
        )
            return targetEncounterStatus[property];

        return targetEncounterStatus?.type ?? "Invalid encounter status";
    };

    export const getPaymentTag = (tag, property = "") => {
        if (!property) {
            if (tag || tag == 0)
                return paymentTag.find((t) => t.id == tag)?.type;
            return "Invalid payment tag";
        }

        const targetTag = paymentTag.find((t) => t.id == tag);

        if (targetTag && targetTag.hasOwnProperty(property))
            return targetTag[property];

        return targetTag?.type ?? "Invalid payment tag";
    };

    export const getPhoneValidation = (phone) => {
        if (!phone) return false;

        return getMobileValidation(phone) || getLandlineValidation(phone);
    };

    export const getMobileValidation = (mobile) => {
        if (!mobile) return false;

        const regex = /^(?:\+?61|0)[2-478][\s-]?\d{4}[\s-]?\d{4}$/;

        return regex.test(String(mobile).replaceAll(" ", ""));
    };

    export const getLandlineValidation = (landline) => {
        if (!landline) return false;

        const regex = /^(0[2-478]\d{8}|\d{8})$/;

        return regex.test(String(landline).replaceAll(" ", ""));
    };

    export const getTollFreeValidation = (phone) => {
        if (!phone) return false;

        const regex =
            /^(1300|1800)[\s-]?\d{3}[\s-]?\d{3}$|^(1300|1800)[\s-]?\d{4}[\s-]?\d{2}$/;

        return regex.test(String(phone).replaceAll(" ", ""));
    };

    export const getEmailValidation = (email) => {
        if (!email) return false;

        // const regex =
        //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))\+?@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // return regex.test(String(email).toLowerCase());
        return isEmail(email);
    };

    export const getDvaStringValidation = (dva) => {
        if (!dva || typeof dva !== "string") return false;

        const regex =
            /^[NVQWST][A-Z ]?[A-Z\d][A-Z\d]?[A-Z\d]?[A-Z\d]?[A-Z\d]?[A-Z\d]?[A-Z\d]?$/;

        // Examples: W 1, NX5, NX5A, SCGW1234,
        return regex.test(dva);
    };

    export const getBsbValidation = (bsb) => {
        if (!bsb) return false;

        const regex = /^\d{6}$/;

        return regex.test(bsb);
    };

    export const getBankAccountNumberValidation = (bAccNo) => {
        if (!bAccNo) return false;

        const regex = /^\d{6,10}$/;

        return regex.test(bAccNo);
    };

    export const getPasswordValidation = (pwd) => {
        if (!pwd) return false;

        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;

        return regex.test(pwd);
    };

    export const splitPaymentAmount = (payment) => {
        const { amount, processingFee, includesGST } = payment;

        const result = {
            processing: Number(processingFee), // exclude when calculate GST
            total: Number(amount), // amount received in bank (total)
            gst: Number(0), // based on (amount - processingFee)
            amount: includesGST // NET amount without GST (if applicable) or processing fee
                ? Number((amount - processingFee) / 1.1)
                : Number(amount - processingFee), // actual amount to calculate GST
        };

        if (includesGST)
            result.gst = result.total - result.amount - result.processing;

        return result;
    };

    export const isObjectEmpty = (obj) => {
        if (
            obj === null ||
            obj === undefined ||
            typeof obj !== "object" ||
            obj.constructor !== Object
        )
            return true;

        return Object.keys(obj).length === 0;
    };

    export const areObjectEqual = (obj1, obj2) => {
        // if (typeof obj1 !== typeof obj2) return false;

        // if (typeof obj1 !== "object" || obj1 === null) return obj1 === obj2;

        // if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;

        // for (let key in obj1) {
        //     if (
        //         !obj2.hasOwnProperty(key) ||
        //         !areObjectEqual(obj1[key], obj2[key])
        //     )
        //         return false;
        // }

        // return true;
        return isEqual(obj1, obj2);
    };

    export const isFunctionEmpty = (func) => {
        const emptyFunc1 = () => {};

        function emptyFunc2() {}

        return (
            emptyFunc1 == func.toString().trim() ||
            emptyFunc2 == func.toString().trim()
        );
    };

    export const calculateTotalFee = (obj) => {
        obj.totalFee = Number(
            (obj.internalProcessingFee + obj.actualGap + obj.rebate).toFixed(2),
        );
    };

    export const getDisplayTotal = (obj) => {
        return getAmountInCurrency(
            obj.internalProcessingFee +
                (obj.actualGap + obj.rebate) * (obj.addGST ? 1.1 : 1),
        );
    };

    export const turnOnEncounterNotification = async (encounter) => {
        if (!encounter.disableNotifications) return;
        let patientEncounterDetails =
            await apiMethods.getMethod.getPatientEncounterById(encounter.id);

        const patientDetails = patientEncounterDetails.patient;

        // sanitize encounter details for update
        patientEncounterDetails = {
            ...patientEncounterDetails,
            doctor: { id: patientEncounterDetails.doctor?.id ?? 0 },
            surgeon: {
                id: patientEncounterDetails.surgeon?.id ?? 0,
                providerUniqueId:
                    patientEncounterDetails.surgeon?.providerUniqueId ?? 0,
            },
            hospital: { id: patientEncounterDetails.hospital?.id ?? 0 },
            doctorProvider: {
                number: patientEncounterDetails.doctorProvider?.number ?? 0,
            },
            billingData: null,
            PatientEncounterPIPData: null,
            PatientEncounterWorkCoverData: null,
            PatientEncounterTrafficAccidentData: null,
            disableNotifications: false,
        };
        if (patientEncounterDetails.hospital.id == 0)
            patientEncounterDetails.hospitalId = 0;

        if (
            patientEncounterDetails.billingData &&
            patientEncounterDetails.billingData.length
        ) {
            for (
                var i = 0;
                i < patientEncounterDetails.billingData.length;
                i++
            ) {
                patientEncounterDetails.billingData[i].patientMedicareNo =
                    patientDetails.medicareNo ? patientDetails.medicareNo : "";
                patientEncounterDetails.billingData[i].patientMedicareRefNo =
                    patientDetails.medicareRefNo;

                if (patientDetails.insurance) {
                    patientEncounterDetails.billingData[i].patientInsurance =
                        patientDetails.insurance;
                }

                if (
                    patientDetails.insuranceType == 20 &&
                    patientDetails.veteranNo
                )
                    patientEncounterDetails.billingData[i].patientVeteranNo =
                        patientDetails.veteranNo;

                patientEncounterDetails.billingData[i].patientInsuranceId =
                    patientDetails.insuranceId;
                patientEncounterDetails.billingData[i].patientMembershipNo =
                    patientDetails.membershipNo
                        ? patientDetails.membershipNo
                        : "";
                patientEncounterDetails.billingData[i].patientMembershipRefNo =
                    patientDetails.membershipRefNo;
                patientEncounterDetails.billingData[i].patientInsuranceType =
                    patientDetails.insuranceType;
            }
        }

        if (patientDetails.insuranceType == 16) {
            if (workerCompensation?.id)
                patientEncounterDetails.patientEncounterWorkCoverData = {
                    workCoverAuthority: workerCompensation.id,
                    email: workerCompensationObj?.insurerEmail
                        ? workerCompensationObj.insurerEmail
                        : workerCompensation.email,
                };
            else if (
                patientEncounterDetails.patientEncounterWorkCoverData
                    ?.workCoverAuthority
            )
                delete patientEncounterDetails.patientEncounterWorkCoverData;
        } else if (
            patientEncounterDetails.patientEncounterWorkCoverData
                ?.workCoverAuthority
        )
            delete patientEncounterDetails.patientEncounterWorkCoverData;

        if (patientDetails.insuranceType == 30) {
            patientEncounterDetails.patientEncounterPIPData = {
                email: publicInPrivateObj.email ? publicInPrivateObj.email : "",
                vendorNumbers: publicInPrivateObj.vendorNumbers
                    ? publicInPrivateObj.vendorNumbers
                    : "",
            };
        } else if (patientEncounterDetails.patientEncounterPIPData?.email)
            delete patientEncounterDetails.patientEncounterPIPData;

        await apiMethods.putMethod
            .updatePatientEncounter(patientEncounterDetails, false, "Turn on notifications")
            .then((res) => {
                if (res.id) {
                    encounter.disableNotifications = false;
                }
            });
    };

    export function getYearsOrMonthsOld(d) {
        if (!d) return "-";

        const dob = new Date(d);
        if (dob >= new Date()) return "-";
        let ageString;

        const yearDiff = new Date().getFullYear() - dob.getFullYear();
        const monthDiff = new Date().getMonth() - dob.getMonth();
        const dateDiff = new Date().getDate() - dob.getDate();

        if (yearDiff > 2) {
            if (monthDiff > 0 || (monthDiff === 0 && dateDiff >= 0)) {
                ageString = `${yearDiff} yrs`;
            } else {
                ageString = `${yearDiff - 1} yrs`;
            }
        } else if (yearDiff === 2) {
            if (monthDiff > 0 || (monthDiff === 0 && dateDiff >= 0)) {
                ageString = `${yearDiff} yrs`;
            } else {
                const mo = 24 + monthDiff + (dateDiff < 0 ? -1 : 0);
                ageString = `${mo} mo`;
            }
        } else {
            const mo = 12 * yearDiff + monthDiff + (dateDiff < 0 ? -1 : 0);
            ageString = `${mo} mo`;
        }

        return ageString;
    }

    export const showException = (error, errorFunc) => {
        console.log(error);
        ErrorDetail.set(null);
        ErrorModalCloseFunction.set(errorFunc ?? (() => {}));
        ShowErrorModal.set(true);
    };

    export function showError(errorMsg, errorFunc, showMsg = true) {
        console.log(errorMsg);
        if (
            showMsg &&
            errorMsg &&
            typeof errorMsg !== "object" &&
            !errorMsg.includes("{")
        ) {
            ErrorDetail.set(errorMsg);
        }

        ErrorModalCloseFunction.set(errorFunc ?? (() => {}));
        ShowErrorModal.set(true);
    }

    export const getRatioPercentageValue = (numerator, denominator) => {
        const commonDivisor = getGreatestCommonDivisor(numerator, denominator);

        const simplifiedNumerator = numerator / commonDivisor;

        const simplifiedDenominator = denominator / commonDivisor;

        return getNumber(
            (simplifiedNumerator / simplifiedDenominator) * 100,
            2,
        );
    };

    export const getGreatestCommonDivisor = (a, b) =>
        b === 0 ? a : getGreatestCommonDivisor(b, a % b);

    export const setErrorStyle = (id, placeholder = "") => {
        const field = document.getElementById(`${id}`);
        if (field) {
            field.style.outline = "red solid 2px";
            if (placeholder) field.placeholder = `${placeholder} is mandatory`;
        }
    };

    export const resetDefaultStyle = (id, placeholder = "") => {
        const field = document.getElementById(`${id}`);
        if (field) {
            field.style.outline = "none";
            if (placeholder) field.placeholder = `${placeholder}`;
        }
    };

    export const formatPortalUrls = (entry = "", id = Number(0)) => {
        const restrictedEntries = ["i", "r", "e", "n"];

        if (!entry || !id || !restrictedEntries.includes(entry)) return "";

        const hostName = window.location.hostname;

        const subDomain = hostName.split(".")[0];

        const formattedSubDomain =
            subDomain == "app" // prod
                ? "portal"
                : subDomain == "localhost" // localhost
                  ? "new-portal"
                  : `${subDomain}-portal`; // new-, nad-

        let url = `https://${formattedSubDomain}.tcihealth.com.au/?${entry}=${id}`;

        return new URL(url);
    };

    export const openPortalPage = async (data, patientDetails = {}) => {
        if (!data || isObjectEmpty(data)) return;

        const { patientId } = data;

        if (!patientDetails || isObjectEmpty(patientDetails))
            patientDetails =
                await apiMethods.getMethod.getPatientById(patientId);

        if (!patientDetails || isObjectEmpty(patientDetails))
            return showError(
                "Failed to load patient details, please refresh the page and try again and contact support if the issue persists.",
            );

        let paramString = "";

        const { firstName, lastName, birthDate } = patientDetails;
        const patientDob = getFormatDate(birthDate)
            .split("/")
            .reverse()
            .join("-");
        const patientName = lastName ? lastName : firstName;

        if (data.hasOwnProperty("relTo")) {
            // Receipts
            const { relTo, relId } = data;
            paramString += `${relTo == 0 ? "e" : "i"}=${relId}&dob=${patientDob}&l=${patientName}`;
        } else if (data.hasOwnProperty("estimateNumber"))
            // Quotes
            paramString += `e=${data.id}&dob=${patientDob}&l=${patientName}`;
        else if (data.hasOwnProperty("invoiceNumber")) {
            // Invoices
            paramString += `i=${data.id}&dob=${patientDob}&l=${patientName}`;
        }

        const url = `https://${window.location.hostname}/portal?${paramString}`;

        window.open(url, "_blank");
    };

    export const abortRequest = () => {
        globalAbortController.abort();

        globalAbortController = new AbortController();
    };

    export const getEstimateStatus = (id) => {
        if (id || id == 0)
            return estimateStatus.find((status) => status.id == id)?.type;

        return "Unknown quote status";
    };

    export const getInvoiceStatus = (id) => {
        if (id || id == 0)
            return invoiceStatus.find((status) => status.id == id)?.type;

        return "Unknown invoice status";
    };

    export const getAccountCalendarEventType = (id) => {
        if (id || id == 0)
            return accountCalendarEventType.find((ace) => ace.id == id)?.type;
        else return "Unknown event type";
    };

    export const getAccountCalendarRepeatIntervalType = (id) => {
        return accountCalendarRepeatIntervalType.find((type) => type.id == id)
            ?.type;
    };

    export const isDateInPast = (date, compareDate = getTodayWithTime()) => {
        if (!date) return false;

        const d1 = new Date(date);
        const d2 = new Date(compareDate);

        const d1WithoutTime = new Date(
            d1.getFullYear(),
            d1.getMonth(),
            d1.getDate(),
        );
        const d2WithoutTime = new Date(
            d2.getFullYear(),
            d2.getMonth(),
            d2.getDate(),
        );

        if (d1WithoutTime.getTime() == d2WithoutTime.getTime()) return false;

        return d1 < d2;
    };

    export const isDateInPastOrToday = (date, compareDate = getTodayWithTime()) => {
        if (!date) return false;

        const d1 = new Date(date);
        const d2 = new Date(compareDate);

        const d1WithoutTime = new Date(
            d1.getFullYear(),
            d1.getMonth(),
            d1.getDate(),
        );
        const d2WithoutTime = new Date(
            d2.getFullYear(),
            d2.getMonth(),
            d2.getDate(),
        );

        return d1WithoutTime <= d2WithoutTime;
    };

    export const isDateAndTimeInPast = (
        date,
        compareDate = getTodayWithTime(),
    ) => {
        if (!date) return false;

        const d1 = new Date(date);
        const d2 = new Date(compareDate);

        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return false;

        return d1.getTime() < d2.getTime();
    };

    export const getTime = (date) => {
        if (!date) return "";
        date = new Date(date);
        return `${date.getHours()}:${date.getMinutes().toString().padStart(2, "0")}`;
    };

    /**
     * Checks whether the provided date falls inside configured business hours.
     * Defaults to 08:00–18:00 Monday through Friday.
     */
    export const isWithinBusinessHours = (
        date,
        {
            startHour = 8,
            startMinute = 0,
            endHour = 20,
            endMinute = 0,
            workingDays = [1, 2, 3, 4, 5],
        } = {},
    ) => {
        if (!date) return false;

        const targetDate = new Date(date);
        if (isNaN(targetDate.getTime())) return false;

        if (!Array.isArray(workingDays) || !workingDays.length) return false;

        const dayOfWeek = targetDate.getDay();
        if (!workingDays.includes(dayOfWeek)) return false;

        const totalMinutes = targetDate.getHours() * 60 + targetDate.getMinutes();
        const businessStartMinutes = startHour * 60 + startMinute;
        const businessEndMinutes = endHour * 60 + endMinute;

        if (businessEndMinutes <= businessStartMinutes) return false;

        return (
            totalMinutes >= businessStartMinutes && totalMinutes < businessEndMinutes
        );
    };

    export function getSVGClassNameFromClick(event) {
        const classList = [];
        const targetElement = event.target || event.srcElement;
        if (targetElement?.classList)
            classList.push(...targetElement.classList);

        if (targetElement?.parentNode?.classList)
            classList.push(...targetElement.parentNode.classList);

        if (targetElement?.parentNode?.parentNode?.classList)
            classList.push(...targetElement.parentNode.parentNode.classList);

        if (targetElement?.parentNode?.parentNode?.parentNode?.classList)
            classList.push(
                ...targetElement.parentNode.parentNode.parentNode.classList,
            );

        return classList;
    }

    export function getDisplayUserName(row) {
        if (row.userId === 0) return "-";
        else if (row.userId < 0) return "Patient";
        else return getText(row.userName);
    }

    export const goToDownloadPage = (type, id, isRegenerate) => {
        if (!id && type != 15) return showError("File id missing");
        const userData = get(user);
        const url = `${serverUrl}/File/view/${type}/${id}/filename/?u=${userData.id}&x=${cryptoJS.MD5(X_Device_ID)}&r=${cryptoJS.MD5(userData.refreshToken)}${isRegenerate ? "&rg=" + getRandomGID() : ""}`;

        const _isSafari = () => {
            const userAgent = navigator.userAgent;
            return (
                /Safari/.test(userAgent) && !/Chrome|Chromium/.test(userAgent)
            );
        };

        if (!_isSafari()) window.open(url);
        else {
            const newWindow = window.open("", "_blank");
            if (!newWindow)
                showError(
                    "Unable to open new tab to download file, please check your browser settings and try again later or contact support...",
                );
            else newWindow.location.href = url;
        }
    };

    export const downloadAccountReport = (id) => {
        if (!id) return showError("File id missing");
        const userData = get(user);
        const url = `${serverUrl}/File/view/${id}/filename/?u=${userData.id}&x=${cryptoJS.MD5(X_Device_ID)}&r=${cryptoJS.MD5(userData.refreshToken)}`;
        window.open(url);
    };

    export const shallowCopy = (inputObj) => {
        const str = JSON.stringify(inputObj);
        try {
            return JSON.parse(str);
        } catch (error) {
            showError(error);
            return null;
        }
    };

    export function showInfo(info) {
        if (!info) return;
        ShowInfoModal.set(true);
        InfoDetail.set(info);
    }

    export function getYYYYMMDD(date) {
        const dateObj = new Date(date);
        return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1)
            .toString()
            .padStart(
                2,
                "0",
            )}-${dateObj.getDate().toString().padStart(2, "0")}`;
    }

    export function getHHMM(date) {
        if (!date) return "";
        date = new Date(date);
        return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
    }

    export const renderTFIcons = (boolValue) => {
        if (boolValue)
            return `<div class="flex flex-1 items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>`;
        else
            return `<div class="flex flex-1 items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6 text-secondary" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>`;
    };

    export const getDaysDifferFrom = (days, baseDate) => {
        if (!baseDate) baseDate = new Date();
        const date = new Date(baseDate);
        date.setDate(date.getDate() + days);
        return getYYYYMMDD(date);
    };

    export const getYearsDifferFrom = (years, baseDate) => {
        if (!baseDate) baseDate = new Date();
        const date = new Date(baseDate);
        date.setFullYear(date.getFullYear() + years);
        return getYYYYMMDD(date);
    };

    export const isSameDate = (date1, date2) => {
        const d1 = new Date(date1);
        const d2 = new Date(date2);

        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    }

    export const isNumeric = (str) => {
        if (typeof str != "string") return false;
        return !isNaN(str) && !isNaN(parseFloat(str));
    };

    export const loadDoctors = async (filterText) => {
        const res = filterText
            ? await apiMethods.getMethod.getAccount(0, 999999, {
                  search: filterText,
              })
            : [];

        if (!res.results?.length) return [];

        const result = [];
        let targetID = null;
        let targetDoctor;
        if (typeof filterText === "number" || isNumeric(filterText))
            targetID = Number(filterText);

        res.results.map((doctor) => {
            const { fullName, preferredName } = doctor;

            if (targetID === doctor.id)
                targetDoctor = {
                    ...doctor,
                    displayName: `${fullName} ${preferredName ? "(" + preferredName + ")" : ""}`,
                };
            else
                result.push({
                    ...doctor,
                    displayName: `${fullName} ${preferredName ? "(" + preferredName + ")" : ""}`,
                });
        });
        if (targetDoctor) result.unshift(targetDoctor);

        return result;
    };

    export const previewImage = (imageObj) => {
        previewImageObj.set(imageObj);
        showImagePreviewModal.set(true);
    };

    export const getRandomGID = () => {
        return Math.floor(Math.random() * 9000 + 1000);
    };

    export const getDisplaySurgeonName = (surgeon, defaultName = "") => {
        if (!surgeon || isObjectEmpty(surgeon)) return defaultName;

        const { title, firstName, middleName, lastName } = surgeon;

        return `${title ? getTitle(title) : ""} ${firstName ?? ""} ${middleName ?? ""} ${
            lastName ?? ""
        }`;
    };

    export const getDisplayPatientName = (patient) => {
        const resultArr = [];
        let title = getTitle(patient.title);

        if (title) resultArr.push(title);
        if (patient.firstName) resultArr.push(patient.firstName);
        if (patient.middleName) resultArr.push(patient.middleName);
        if (patient.lastName) resultArr.push(patient.lastName);
        return resultArr.join(" ");
    };

    export const loadCalendarEventCategories = async () => {
        if (get(IsLoadingCalendarEventCategories)) return;
        IsLoadingCalendarEventCategories.set(true);
        const currentUserGroupId = getCurrentUserGroupId();
        const filters = {};
        if (currentUserGroupId || currentUserGroupId === 0)
            filters["filter[groupId]"] = currentUserGroupId;
        apiMethods.getMethod
            .getCalendarEventsCategories(0, 9999, filters)
            .then((res) => {
                updateCalendarEventCategories(res?.results);
                IsLoadingCalendarEventCategories.set(false);
            })
            .catch((err) => {
                showException(err);
                IsLoadingCalendarEventCategories.set(false);
            });
    };

    const getCurrentUserGroupId = () => {
        const currentUser = get(user);
        // for admin/dev/support show all
        if (
            currentUser.role === DirectUserRoles.Admin ||
            currentUser.role === DirectUserRoles.Developer ||
            currentUser.role === DirectUserRoles.Support
        )
            return undefined;
        if (currentUser.groupId || currentUser.groupId === 0)
            return currentUser.groupId;
        if (
            currentUser.role === DirectUserRoles.Patient ||
            currentUser.role === DirectUserRoles.Doctor ||
            currentUser.role === DirectUserRoles.Manager
        )
            return FallBackGroupId;
    };

    export const updateCalendarEventCategories = (results) => {
        if (results && results.length) CalendarEventCategories.set(results);
        else CalendarEventCategories.set([]);
    };

    export const getEventColor = (event) => {
        if (typeof event === "number") {
            const allCats = get(CalendarEventCategories);
            const targetCategory = allCats.find(
                (cat) => cat.categoryType === event,
            );
            return targetCategory?.calendarColour
                ? targetCategory.calendarColour
                : defaultCalendarEventColor;
        }
        // return category specific color;
        if (event?.eventCategory && event?.eventCategoryColour)
            return event.eventCategoryColour;

        if (event.eventType || event.eventType === 0) {
            const allCats = get(CalendarEventCategories);
            const targetCat = allCats.find(
                (cat) => cat.categoryType === event.eventType,
            );
            if (targetCat && targetCat.calendarColour)
                return targetCat.calendarColour;
        }
        return defaultCalendarEventColor;
    };

    export const getContrastBlackOrWhiteAgainstEventColor = (
        event,
        lightColor,
        darkColor,
    ) => {
        const eventColor = getEventColor(event);
        if (!eventColor) return lightColor;
        var color =
            eventColor.charAt(0) === "#"
                ? eventColor.substring(1, 7)
                : eventColor;
        var r = parseInt(color.substring(0, 2), 16); // hexToR
        var g = parseInt(color.substring(2, 4), 16); // hexToG
        var b = parseInt(color.substring(4, 6), 16); // hexToB
        var uicolors = [r / 255, g / 255, b / 255];
        var c = uicolors.map((col) => {
            if (col <= 0.03928) {
                return col / 12.92;
            }
            return Math.pow((col + 0.055) / 1.055, 2.4);
        });
        var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
        return L > 0.179 ? darkColor : lightColor;
    };

    export const getContrastBlackOrWhiteColor = (
        inputColor,
        lightColor = "#fff",
        darkColor = "#000",
    ) => {
        if (!inputColor) return darkColor;
        const color =
            inputColor.charAt(0) === "#"
                ? inputColor.substring(1, 7)
                : inputColor;
        const r = parseInt(color.substring(0, 2), 16); // hexToR
        const g = parseInt(color.substring(2, 4), 16); // hexToG
        const b = parseInt(color.substring(4, 6), 16); // hexToB
        const uicolors = [r / 255, g / 255, b / 255];
        const c = uicolors.map((col) => {
            if (col <= 0.03928) {
                return col / 12.92;
            }
            return Math.pow((col + 0.055) / 1.055, 2.4);
        });
        const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
        return L > 0.179 ? darkColor : lightColor;
    };

    export const getOptionLabelForSurgeon = ({
        firstName,
        lastName,
        title,
        speciality,
        state,
    }) =>
        `${getTitle(title)} ${firstName} ${lastName} (${speciality})`;

    export const viewEncounterInSidePanel = (id) => {
        // if (!id) return showInfo("Missing Encounter ID");
        // EncounterSidePanelProps.set({id})
    };

    export const openViewEncounterNewPage = (id) => {
        const url = `${location.origin}/#/PatientEncounter/view/${id}`;
        window.open(url, "_blank");
    };

    export const getBackEndDeleteType = (type) => {
        switch (type) {
            case DeleteRepeatingEventOptions.thisAndFollowing:
                return 1;
            case DeleteRepeatingEventOptions.allEvents:
                return 2;
            case DeleteRepeatingEventOptions.thisOnly:
            default:
                return 0;
        }
    };

    export const parseTemplateTypeName = (name) => {
        if (!name || typeof name !== "string") return "";
        let parsedName = "";
        for (let i = 0; i < name.length; i++) {
            let thisChar = name.charAt(i);
            let nextChar = name.charAt(i + 1);
            let prevChar = name.charAt(i - 1);
            let isThisCharUpperCase = thisChar && thisChar.match(/[A-Z]/g);
            let isNextCharUpperCase = nextChar && nextChar.match(/[A-Z]/g);
            let isPrevCharUpperCase = prevChar && prevChar.match(/[A-Z]/g);
            let isThisCharNumeric = thisChar && thisChar.match(/[0-9]/g);
            let isPrevCharNumeric = prevChar && prevChar.match(/[0-9]/g);
            let isNextCharNumeric = nextChar && nextChar.match(/[0-9]/g);
            let isThisCharLowerCase = thisChar && thisChar.match(/[a-z]/g);
            let isNextCharLowerCase = nextChar && nextChar.match(/[a-z]/g);
            let isPrevCharLowerCase = prevChar && prevChar.match(/[a-z]/g);
            if (i) {
                // always skip first letter;
                if (
                    (isPrevCharNumeric && !isThisCharNumeric) ||
                    (isThisCharNumeric && !isPrevCharNumeric)
                )
                    parsedName += " ";

                if (
                    isPrevCharLowerCase &&
                    (isThisCharUpperCase || isThisCharNumeric)
                )
                    parsedName += " ";

                if (
                    isPrevCharUpperCase &&
                    isThisCharUpperCase &&
                    nextChar &&
                    isNextCharLowerCase
                )
                    parsedName += " ";
            }
            parsedName += thisChar;
        }
        return parsedName;
    };

    export const encodeSearchParams = (string) => {
        if (!string) return "";

        return encodeURIComponent(string);
    };

    export const decodeSearchParams = (params) => {
        if (!params) return "";

        return decodeURIComponent(params);
    };

    export const refreshTokenAfterSignIn = async () => {
        const { expiration } = get(user);

        if (new Date(expiration) < new Date()) await refreshToken();
    };

    export const syncDefaultDoctorFilter = async (
        filters = {},
        propertyName = "",
    ) => {
        if (!filters || !propertyName) return {};

        if (filters[propertyName]) return filters;

        if (!get(user).defaultFilters || !get(user).defaultFilters.length)
            return filters;

        if (!get(defaultFilters) || !get(defaultFilters).userFilter)
            await cacheDefaultFilters();

        const defaultDoctorFilter = get(defaultFilters).userFilter?.find(
            (filter) =>
                filter.id ==
                get(user).defaultFilters.find((f) => f.filterType == 0)
                    ?.filterId,
        );

        if (!defaultDoctorFilter) return filters;

        filters[propertyName] = defaultDoctorFilter.filter;

        return filters;
    };

    export const getEncounterDischargeDateWithFallBackDuration = (
        encounter,
    ) => {
        if (!encounter.scheduledDate) return "";
        const scheduledDate = new Date(encounter.scheduledDate);
        let dischargeDate = new Date(encounter.dischargeDate);
        if (dischargeDate > scheduledDate) return encounter.dischargeDate;
        else {
            dischargeDate = new Date(
                scheduledDate.getTime() +
                    FallBackEncounterDurationMins * 60 * 1000,
            );
            const year = dischargeDate.getFullYear();
            const month = (dischargeDate.getMonth() + 1)
                .toString()
                .padStart(2, "0");
            const day = dischargeDate.getDate().toString().padStart(2, "0");
            const hours = dischargeDate.getHours().toString().padStart(2, "0");
            const minutes = dischargeDate
                .getMinutes()
                .toString()
                .padStart(2, "0");
            const seconds = dischargeDate
                .getSeconds()
                .toString()
                .padStart(2, "0");

            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        }
    };

    export const getSearchSurgeonOptions = (surgeons = [], includeState = true, includeSpeciality = false) => {
        let res = [];
        if (!surgeons || !surgeons.length) return res;

        surgeons.map((surgeon) => {
            // object key orders are fixed, don't reorder.
            res.push({
                key: surgeon.uniqueId,
                value: _getName(surgeon, includeState, includeSpeciality),
                displayName: _getName(surgeon, includeState, includeSpeciality),
                ...surgeon,
            });
        });

        return res;
    };

    export const _getName = (data, includeState, includeSpeciality) => {
        const { firstName, lastName, title, state, speciality } = data;
        return `${getTitle(title)} ${firstName} ${lastName}${
            includeState && state ? ", " + state.toUpperCase() : ""
        }${
            includeSpeciality && speciality ? " (" + speciality + ")" : ""
        }`;
    };

    export const getDoctorName = (doctor) => {
        if (!doctor || isObjectEmpty(doctor)) return "";
        const title = doctor.titleName ?? getTitle(doctor.title) ?? "";
        const name = doctor.fullName ?? doctor.firstName + doctor.lastName;
        return `${title} ${name}`;
    };

    export const getDoctorNameShortcut = (doctor = {}) => {
        if (!doctor) return "";

        if (typeof doctor === "object") {
            if (isObjectEmpty(doctor)) return "";
            const { firstName, lastName } = doctor;
            return `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`;
        }

        if (typeof doctor === "string") {
            const words = doctor.trim().split(/\s+/);
            const title = words[0];
            const validTitle = TitleType.some((item) => item.type === title);

            const nameWords = validTitle ? words.slice(1) : words;

            return nameWords.length >= 2
                ? nameWords
                      .slice(-2)
                      .map((word) => word[0]?.toUpperCase() ?? "")
                      .join("")
                : (nameWords[0]?.[0]?.toUpperCase() ?? "");
        }

        return "";
    };

    export const getDateForBackend = (date) => {
        if (!date) return "";
        return `${getYYYYMMDD(date)}T${getHHMM(date)}:00`;
    };

    export const getEncounterDurationInMillSec = (encounter) => {
        if (
            !encounter.dischargeDate ||
            new Date(encounter.scheduledDate) >=
                new Date(encounter.dischargeDate)
        )
            return FallBackEncounterDurationMins * 60 * 1000;
        return getTimeDiffInMillSec(
            encounter.scheduledDate,
            encounter.dischargeDate,
        );
    };

    export const getTimeDiffInMillSec = (end, start) => {
        const endTime = new Date(end).getTime();
        const startTime = new Date(start).getTime();

        return endTime - startTime;
    };

    export const addHoursToDate = (dateStr, hours) => {
        const date = new Date(dateStr);

        const milliSecondsToAdd = hours * 60 * 60 * 1000;

        date.setTime(date.getTime() + milliSecondsToAdd);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hoursFormatted = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day}T${hoursFormatted}:${minutes}:${seconds}`;
    };

    export const splitCamelCase = (text) => {
        if (!text || typeof text !== "string") return "";
        const ar = text.split(/(?=[A-Z])/);
        if (ar.length) ar[0] = ar[0][0].toUpperCase() + ar[0].substring(1);
        return ar.join(" ");
    };

    export const scrollIntoView = (id, options = { behavior: "smooth" }) => {
        if (!id) return;
        const ele = document.getElementById(id);
        if (ele) ele.scrollIntoView(options);
    };

    export const viewLog = (type, id, closeFunction) => {
        if (!type || !id) return;
        viewLogDetails.set({
            type,
            id,
            closeFunction,
        });
        showViewLogModal.set(true);
    };

    export const showPopupNotification = (title, contentText) => {
        // simple note, with close button only
        if (!contentText) return;
        globalNotificationModalDetails.set({
            contentText,
            title,
        });
        showGlobalNotificationModal.set(true);
    };

    export const showConfirmAction = ({
        title = "Confirmation",
        message = "",
        actions = [],
        modalMaxWidth = "",
    }) => {
        if (!message) return;

        confirmActionModalDetails.set({
            title,
            message,
            actions,
            modalMaxWidth,
        });

        showConfirmActionModal.set(true);
    };

    const isCommunicationDisabled = (encounter) => {
        if (!encounter) return false;

        if (typeof encounter.disableNotifications === "boolean") {
            return encounter.disableNotifications;
        }

        return false;
    };

    export const runWithCommunicationsCheck = (encounter, onProceed) => {
        const proceed = () =>
            typeof onProceed === "function" ? onProceed() : undefined;

        if (!isCommunicationDisabled(encounter)) {
            return proceed();
        }

        communicationConfirmationModalDetails.set({
            encounterDetails: encounter,
            onProceed,
        });

        showCommunicationConfirmationModal.set(true);
    };

    export const privateInsuranceFundHasCoverTypes = (fundId) =>
        PrivateInsuranceFundCoverType.some((fund) => fund.id === fundId);

    export const getPrivateInsuranceFundCoverTypes = (fundId) => {
        if (!privateInsuranceFundHasCoverTypes(fundId)) return [];

        return PrivateInsuranceFundCoverType.find((fund) => fund.id === fundId)
            .coverTypes;
    };

    export const getPrivateInsuranceFundDefaultCoverType = (fundId) => {
        if (!privateInsuranceFundHasCoverTypes(fundId)) return "";

        return (
            getPrivateInsuranceFundCoverTypes(fundId).find(
                (type) => type.isDefault,
            )?.value ?? getPrivateInsuranceFundCoverTypes(fundId)[0].value
        );
    };

    export const getMinDateOfPayment = (
        dateObj = {
            receivedDate: null,
            transactionDate: null,
        },
        typeOfPayment,
    ) => {
        const today = new Date();

        // for pending refund, refunded and write-off payments - ignore transaction date when getting min date
        const paymentTypeIgnoreTransactionDate = [4, 5, 7].includes(
            typeOfPayment,
        );

        /*
            If domain is app:
                1. if type of payment is [Pending Refund, Refunded, Write-Off], no limitation on receive date
                2. other type of payment with selected transaction date, limit to transaction date
                3. no transaction date, no limit
            Else:
                1. if receive date is selected, limit to receive date
                2. if type of payment is [Pending Refund, Refunded, Write-Off], allow max of 2 days before today
                3. else limit to today
        */
        if (isEnvApp()) {
            if (paymentTypeIgnoreTransactionDate) return null;
            else if (dateObj.transactionDate)
                return new Date(dateObj.transactionDate);
            else return null;
        } else if (dateObj.transactionDate)
            return new Date(dateObj.transactionDate);
        else if (paymentTypeIgnoreTransactionDate)
            return new Date(today.setDate(today.getDate() - 2));
        else return today;
    };

    export const copyObjContent = (obj, successInfo = "") => {
        if (typeof obj == "string") {
            navigator.clipboard
                .writeText(obj)
                .then(() => showInfo(successInfo));
            return;
        }

        const jsonText = JSON.stringify(obj);

        navigator.clipboard
            .writeText(jsonText)
            .then(() => showInfo(successInfo))
            .catch((err) => showError(err));
    };

    export const getPatientAge = (birthDate) => {
        if (!birthDate) return 0;

        const date = new Date();
        const [year, month, day] = birthDate.split("-");

        let age = date.getFullYear() - year;

        if (
            date.getMonth() < month - 1 ||
            (date.getMonth() == month - 1 && date.getDate() < day)
        )
            age--;

        return age;
    };

    export const getPatientAgeString = (birthDate) => {
        if (!birthDate) return "-";

        // Normalize: support "YYYY-MM-DD" and ISO "YYYY-MM-DDTHH:mm:ss..."
        const d = birthDate.includes("T") ? birthDate : `${birthDate}T00:00:00`;
        const dob = new Date(d);

        // Invalid date guard
        if (Number.isNaN(dob.getTime())) return "-";

        // Same rule as your second function (reject today/future)
        if (dob >= new Date()) return "-";

        const now = new Date();
        const yearDiff = now.getFullYear() - dob.getFullYear();
        const monthDiff = now.getMonth() - dob.getMonth();
        const dateDiff = now.getDate() - dob.getDate();

        let ageString;

        if (yearDiff > 2) {
            if (monthDiff > 0 || (monthDiff === 0 && dateDiff >= 0)) {
            ageString = `${yearDiff} yrs`;
            } else {
            ageString = `${yearDiff - 1} yrs`;
            }
        } else if (yearDiff === 2) {
            if (monthDiff > 0 || (monthDiff === 0 && dateDiff >= 0)) {
            ageString = `${yearDiff} yrs`;
            } else {
            const mo = 24 + monthDiff + (dateDiff < 0 ? -1 : 0);
            ageString = `${mo} mo`;
            }
        } else {
            const mo = 12 * yearDiff + monthDiff + (dateDiff < 0 ? -1 : 0);
            ageString = `${mo} mo`;
        }

        return ageString;
    };

    export const sendResetPwdEmail = async (email) => {
        if (!email || !isEmail(email)) return;

        await apiMethods.postMethod
            .forgetPwd({ email })
            .then((res) => {
                showInfo("Reset Password Email Sent");
            })
            .catch((err) => showError(err));
    };

    export const useTableScrollMemory = (key) => {
        if (!key) return;

        const saveScroll = (scrollTop = 0, scrollLeft = 0) => {
            const savedRef = get(tableScrollPosition);
            savedRef[key] = { top: scrollTop, left: scrollLeft };
            tableScrollPosition.set(savedRef);
        };

        const restoreScrollPosition = () => {
            const savedRef = get(tableScrollPosition);

            return savedRef[key] || { top: 0, left: 0 };
        };

        return { saveScroll, restoreScrollPosition };
    };

    export const getEncounterPaymentDropdownOption = (
        id,
        propertyName = "",
    ) => {
        if (!id) return "";

        if (!propertyName)
            return encounterPaymentDropdownOptions.find(
                (option) => option.id == id,
            )?.type;

        const targetOption = encounterPaymentDropdownOptions.find(
            (option) => option.id == id,
        );

        return targetOption
            ? targetOption.hasOwnProperty(propertyName)
                ? targetOption[propertyName]
                : targetOption.type
            : "";
    };

    export const getDaysInMonth = (year, month) =>
        new Date(year, month, 0).getDate();

    export const getQuarterRangeByDate = (date, quarterDiff = 0) => {
        if (!(date instanceof Date)) throw new Error("Invalid date");

        const year = date.getFullYear();
        const month = date.getMonth();

        const adjustedMonth = month + quarterDiff * 3;
        const adjustedYear = year + Math.floor(adjustedMonth / 12);
        const finalMonth = ((adjustedMonth % 12) + 12) % 12; // make sure it's a positive number between 0 and 11

        const quarterStartMonth = Math.floor(finalMonth / 3) * 3;
        const quarterStartDate = new Date(adjustedYear, quarterStartMonth, 1);
        const quarterEndDate = new Date(adjustedYear, quarterStartMonth + 3, 0);

        return {
            start: quarterStartDate,
            end: quarterEndDate,
        };
    };

    /**
     * Bulk API call with callback get status
     * @param {number|Array<function>} bulkCountOrApiRequests - number of calls in each bulk (default 5) || all apis to call
     * @param {Array<function>|function} apiRequests - all apis to call || callback to get current progress, num of success and failed calls
     * @param {function} onProgress - callback to get current progress, num of success and failed calls
     * @returns {Promise<allSucceeded: boolean, successCount: number, failureCount: number>}
     */
    export const bulkApi = async (
        bulkCountOrApiRequests,
        apiRequestsOrOnProgress,
        onProgress,
    ) => {
        let bulkCount, apiRequests;

        if (typeof bulkCountOrApiRequests == "number") {
            bulkCount = bulkCountOrApiRequests;
            apiRequests = apiRequestsOrOnProgress;
        } else {
            bulkCount = 5;
            apiRequests = bulkCountOrApiRequests;
            onProgress = apiRequestsOrOnProgress;
        }

        let successCount = 0,
            failureCount = 0,
            currentIndex = 0;

        const batchCall = async () => {
            const batch = [];

            while (
                currentIndex < apiRequests.length &&
                batch.length < bulkCount
            ) {
                const apiMethod = apiRequests[currentIndex];
                const task = apiMethod()
                    .then(() => successCount++)
                    .catch(() => failureCount++)
                    .finally(() => {
                        if (typeof onProgress === "function") {
                            onProgress({
                                current: currentIndex,
                                total: apiRequests.length,
                                successCount,
                                failureCount,
                            });
                        }
                    });
                batch.push(task);
                currentIndex++;
            }

            await Promise.all(batch);
        };

        while (currentIndex < apiRequests.length) {
            await batchCall();
        }

        return {
            allSucceeded: failureCount === 0,
            successCount,
            failureCount,
        };
    };
</script>
